"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckoutTabs = void 0;
var react_1 = __importDefault(require("react"));
var InschrijvenForm_1 = require("./InschrijvenForm");
var BestaandeLeerlingForm_1 = require("./BestaandeLeerlingForm");
function CheckoutTabs() {
    return (react_1.default.createElement("section", { className: "bg-white", id: "afrekenen" },
        react_1.default.createElement("div", { className: "card border-0" },
            react_1.default.createElement("div", { className: "card-header bg-green1 rounded-0 pt-5" },
                react_1.default.createElement("div", { className: "container" },
                    react_1.default.createElement("ul", { className: "nav nav-tabs card-header-tabs nav-fill" },
                        react_1.default.createElement("li", { className: "nav-item" },
                            react_1.default.createElement("a", { className: "text-white nav-item nav-link active", id: "nav-home-tab", "data-toggle": "tab", href: "#nav-home", role: "tab", "aria-controls": "nav-home", "aria-selected": "true" },
                                "Ik ben nieuw",
                                " ",
                                react_1.default.createElement("span", { className: "d-none d-md-inline" }, "bij Ready to school"))),
                        react_1.default.createElement("li", { className: "nav-item" },
                            react_1.default.createElement("a", { className: "text-white nav-item nav-link ", id: "nav-profile-tab", "data-toggle": "tab", href: "#nav-profile", role: "tab", "aria-controls": "nav-profile", "aria-selected": "false" },
                                "Ik kan al inloggen",
                                " ",
                                react_1.default.createElement("span", { className: "d-none d-md-inline" }, "bij Ready to school")))))),
            react_1.default.createElement("div", { className: "container" },
                react_1.default.createElement("div", { className: "tab-content", id: "nav-tabContent" },
                    react_1.default.createElement("div", { className: "tab-pane fade show active", id: "nav-home", role: "tabpanel", "aria-labelledby": "nav-home-tab" },
                        react_1.default.createElement(InschrijvenForm_1.InschrijvenForm, null)),
                    react_1.default.createElement("div", { className: "tab-pane fade", id: "nav-profile", role: "tabpanel", "aria-labelledby": "nav-profile-tab" },
                        react_1.default.createElement(BestaandeLeerlingForm_1.BestaandeLeerlingForm, null)))))));
}
exports.CheckoutTabs = CheckoutTabs;
